import { OrderCreateComponent } from './order-create/order-create.component';
import { OrderTransmissionEditComponent } from './order-transmission-edit/order-transmission-edit.component';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
// import {
//     CalendarDateFormatter,
//     CalendarModule,
//     CalendarMomentDateFormatter,
//     DateAdapter,
//     MOMENT
// } from 'angular-calendar';
// import { adapterFactory } from 'angular-calendar/date-adapters/moment';

import * as moment from 'moment';

import { SharedModule } from 'app/shared/shared.module';
import { OrdersComponent } from './orders.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrderEditComponent } from './order-edit/order-edit.component';
import { OrderStepScansTableComponent } from './order-detail/order-step-scans-table/order-step-scans-table.component';
import { OrderStepPatientsTableComponent } from './order-detail/order-step-patients-table/order-step-patients-table.component';
import { OrderStepFormComponent } from './order-step-form/order-step-form.component';



// export function momentAdapterFactory() {
//     return adapterFactory(moment);
// }

@NgModule({
  declarations: [
    OrdersListComponent,
    OrderCreateComponent,
    OrderTransmissionEditComponent,
    OrdersComponent,
    OrderDetailComponent,
    OrderEditComponent,
    OrderStepScansTableComponent,
    OrderStepPatientsTableComponent,
    OrderStepFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MomentModule,
    // CalendarModule.forRoot(
    //     {
    //         provide: DateAdapter,
    //         useFactory: momentAdapterFactory
    //     },
    //     {
    //         dateFormatter: {
    //             provide: CalendarDateFormatter,
    //             useClass: CalendarMomentDateFormatter
    //         }
    //     }
    // )
  ],
  providers: [
    // {
    //   provide: MOMENT,
    //   useValue: moment
    // }
  ],
  exports: [

  ]
})
export class OrdersModule { }
